<template lang="pug">
div
  div.form-check.mb-3
    input#time_limit.form-check-input(type='checkbox', name='time_limit', @click='setTimeLimit', :checked="time_limit", value=1)
    div.d-flex.align-items-center.mb-3
      label.form-check-label(for='time_limit') 時間制限をつける
      span.upper-master-label.ml-2 Master以上
      UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
  div.form-group(v-if="time_limit")
    .row.pl-4
      .col-12
        div.form-group
          label ページ表示から
          div.row
            .col-4
              .input-group
                input#time_limit_val.form-control(type='text',
                name='time_limit_val',
                placeholder='秒数',
                @input='setTimeLimitVal',
                :value="time_limit_val")
                .input-group-append
                  span.input-group-text 秒
            .col-3
              select.form-control(v-model="time_limit_type")
                option(v-for="(val, key) in time_limit_types", :value="key") {{val}}
            .col-5
              p.text-muted.mt-1 の場合表示
</template>

<script>
import Vue from 'vue'

import { required, url } from 'vuelidate/lib/validators'

import { mapState } from 'vuex'

//libs
import { Chrome } from 'vue-color'

import UpgradeUpperMaster from "../modals/upgrade_upper_master.vue";

export default {
  props: {
    time_limit_types: {type: Object, default: null},
    show_with_parameters: { type: Boolean, default: false },
  },
  data(){
    return {
      prefix_countdown_text_dirty: false,
      is_upgrade_upper_master_modal: false,
    }
  },
  methods: {
    setTimeLimit(e){
      if (!this.show_with_parameters) {
        this.isDisplayModal(e);
      } else {
        this.$store.commit("creative/setTimeLimit", e.target.checked)
      }
    },
    isDisplayModal(e) {
      this.is_upgrade_upper_master_modal = true;
      event.preventDefault();
    },
    setTimeLimitType(e){
      this.$store.commit("creative/setTimeLimitType", e.target.value)
    },
    setTimeLimitVal(e){
      this.$store.commit("creative/setTimeLimitVal", parseInt(e.target.value))
    }
  },
  components: {
    Chrome,
    UpgradeUpperMaster,
  },
  watch: {
  },
  computed: {
    time_limit() {
      return this.$store.state.creative.preview_list.time_limit
    },
    time_limit_type: {
      get: function() {
        return this.$store.state.creative.preview_list.time_limit_type
      },
      set: function(v){
        this.$store.commit("creative/setTimeLimitType", v)
      }
    },
    time_limit_val() {
      return this.$store.state.creative.preview_list.time_limit_val
    },
  },
  async mounted(){
  }
}
</script>
<style lang="scss" scoped>

</style>
